import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import KittLogo from '@public/kitt-logo.svg';
import type { FC, ReactNode } from 'react';
type TServerSignInClick = {
  action: (formData: FormData) => void;
  onSignInClick?: never;
};
type TClientSignInClick = {
  action?: never;
  onSignInClick: () => void;
};
type Props = Readonly<{
  message: ReactNode;
  buttonLabel?: string;
  isLoading?: boolean;
  /**
   * Passed to signInAction via hidden form field so the server action knows where to redirect after auth.
   */
  callbackUrl?: string;
}> & (TServerSignInClick | TClientSignInClick);
export const Unauthorized: FC<Props> = t0 => {
  const $ = _c(15);
  const {
    message,
    buttonLabel: t1,
    isLoading,
    callbackUrl,
    action,
    onSignInClick
  } = t0;
  const buttonLabel = t1 === undefined ? "Sign in" : t1;
  const t2 = action ? "submit" : "button";
  let t3;
  if ($[0] !== buttonLabel || $[1] !== isLoading || $[2] !== onSignInClick || $[3] !== t2) {
    t3 = <Button type={t2} name="sign-in" variant="primary" margin="mt-4" isLoading={isLoading} onClick={onSignInClick}>{buttonLabel}</Button>;
    $[0] = buttonLabel;
    $[1] = isLoading;
    $[2] = onSignInClick;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const button = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Image src={KittLogo} alt="KITT logo" priority={true} width={110} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== message) {
    t5 = <Text.Header color={0} margin="mt-4" align="center" size="xs">{message}</Text.Header>;
    $[6] = message;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== action || $[9] !== button || $[10] !== callbackUrl) {
    t6 = action ? <form action={action}>{callbackUrl != null && <input type="hidden" name="callbackUrl" value={callbackUrl} />}{button}</form> : button;
    $[8] = action;
    $[9] = button;
    $[10] = callbackUrl;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Flex className="h-full bg-gray-800" justify="center" items="center" direction="col"><div className="shadow-soft rounded-xl bg-gray-700/70 p-20"><Flex direction="col" items="center">{t4}{t5}{t6}</Flex></div></Flex>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};